// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportDataModelTenant.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// Import Data Model Tenant
!(function() {
  var m = require('mobx');
  var trackable = require('share/tracking/Izenda.Trackable');
  var ImportDataModelMapping = require('logic/models/Izenda.ImportDataModelMapping');
  var QuerySourceTree = require('./Izenda.QuerySourceTreeMultiLevel');
  var { filter, isEmpty, map } = require('lodash/fp');

  function ImportDataModelTenant(data) {
    var props = {
      tenantName: '',
      tenantId: null,
      status: 0,
      mappings: [],
      sourceConnections: [],
      destinationConnections: [],

      validatedSourceConnections: [],
      validatedDestinationConnections: [],
      querySourceTree: new QuerySourceTree([], null, true),
      destinationQuerySourceTree: new QuerySourceTree([], null, true)
    };

    m.extendObservable(trackable(this), props);

    data && this.poppulateData(data);
  }

  /**
   * Populate Import Data Model Tenant data
   */
  ImportDataModelTenant.prototype.poppulateData = m.action(function(data) {
    this.tenantName = data.tenantName || '';
    this.tenantId = data.tenantId || null;
    this.status = data.status || 0;
    this.sourceConnections = data.sourceConnections;
  });

  /**
   * Populate data after validate
   */
  ImportDataModelTenant.prototype.poppulateDataAfterValidate = m.action(function(data) {
    this.status = data.status || 0;
    this.validatedDestinationConnections = data.destinationConnections;
    this.validatedSourceConnections = data.sourceConnections;
    this.destinationQuerySourceTree.setQuerySources(data.destinationConnections);
    this.querySourceTree.setQuerySources(data.sourceConnections);
  });

   /**
   * Add mapping
   */
  ImportDataModelTenant.prototype.addMapping = m.action(function() {
    this.mappings.push(new ImportDataModelMapping());
  });

   /**
   * Remove empty mappings
   */
  ImportDataModelTenant.prototype.removeEmptyMappings = m.action(function() {
    this.mappings = filter(m => !isEmpty(m.fromConnectionName) && !isEmpty(m.fromSchemaName) && !isEmpty(m.toConnectionName) && !isEmpty(m.toSchemaName), this.mappings);
  });

   /**
   * Build data
   */
  ImportDataModelTenant.prototype.buildData = m.action(function() {
    this.removeEmptyMappings();
    return {
      name: this.tenantName,
      mappings: map(m => {
        return {
          fromConnectionName: m.fromConnectionName,
          fromSchemaName: m.fromSchemaName,
          toConnectionName: m.toConnectionName,
          toSchemaName: m.toSchemaName,
        }
      }, this.mappings)
    };
  });

  module.exports = ImportDataModelTenant;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ImportDataModelTenant.js